require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./link"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./link"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./link")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./link"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__29__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[43],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _AlertNavigator = _interopRequireDefault(__webpack_require__(385));

var _AlertNavigatorLabel = _interopRequireDefault(__webpack_require__(113));

var _AlertNavigatorButtons = _interopRequireDefault(__webpack_require__(115));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var alertNavigatorClassName = _AlertNavigator["default"].alertNavigatorClassName.replace(/"/g, '');

var AlertNavigator = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(AlertNavigator, _Component);

  function AlertNavigator() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = AlertNavigator.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        currentAlert = _this$props.currentAlert,
        alertsLength = _this$props.alertsLength,
        className = _this$props.className,
        onPrev = _this$props.onPrev,
        onNext = _this$props.onNext;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: className + " " + alertNavigatorClassName
    }, /*#__PURE__*/_react["default"].createElement(_AlertNavigatorLabel["default"], {
      currentAlert: currentAlert,
      alertsLength: alertsLength
    }), alertsLength > 1 && /*#__PURE__*/_react["default"].createElement(_AlertNavigatorButtons["default"], {
      currentAlert: currentAlert,
      alertsLength: alertsLength,
      onPrev: onPrev,
      onNext: onNext
    }));
  };

  return AlertNavigator;
}(_react.Component);

exports["default"] = AlertNavigator;
AlertNavigator.propTypes = {
  currentAlert: _propTypes["default"].number.isRequired,
  alertsLength: _propTypes["default"].number.isRequired,
  className: _propTypes["default"].string,
  onPrev: _propTypes["default"].func,
  onNext: _propTypes["default"].func
};
AlertNavigator.defaultProps = {
  currentAlert: 0,
  alertsLength: 0,
  className: ''
};

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = AlertNavigatorLabel;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _AlertNavigatorLabel = _interopRequireDefault(__webpack_require__(387));

var _StringResource = _interopRequireDefault(__webpack_require__(114));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var alertNavigatorLabelClassName = _AlertNavigatorLabel["default"].alertNavigatorLabelClassName.replace(/"/g, '');

function formatNumAlerts(currentAlert, alertsLength) {
  return currentAlert + 1 + "/" + alertsLength;
}

function AlertNavigatorLabel(props) {
  var currentAlert = props.currentAlert,
      alertsLength = props.alertsLength;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: alertNavigatorLabelClassName
  }, formatNumAlerts(currentAlert, alertsLength), " ", _StringResource["default"].get('alerts'));
}

AlertNavigatorLabel.propTypes = {
  currentAlert: _propTypes["default"].number.isRequired,
  alertsLength: _propTypes["default"].number.isRequired
};
AlertNavigatorLabel.defaultProps = {
  currentAlert: 0,
  alertsLength: 0
};

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _PersistentBannerResources = _interopRequireDefault(__webpack_require__(389));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_PersistentBannerResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = AlertNavigatorButtons;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _button = _interopRequireDefault(__webpack_require__(15));

var _arrowLeft_ = _interopRequireDefault(__webpack_require__(58));

var _arrowRight_ = _interopRequireDefault(__webpack_require__(116));

var _AlertNavigatorButtons = _interopRequireDefault(__webpack_require__(390));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var alertNavigatorButtonsClassName = _AlertNavigatorButtons["default"].alertNavigatorButtonsClassName.replace(/"/g, '');

function AlertNavigatorButtons(props) {
  var alertsLength = props.alertsLength,
      onPrev = props.onPrev,
      onNext = props.onNext;
  var currentAlert = props.currentAlert + 1;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: alertNavigatorButtonsClassName
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    varient: "icon",
    icon: _arrowLeft_["default"].id,
    disabled: currentAlert === 1,
    onClick: onPrev
  }), /*#__PURE__*/_react["default"].createElement(_button["default"], {
    varient: "icon",
    icon: _arrowRight_["default"].id,
    disabled: currentAlert === alertsLength,
    onClick: onNext
  }));
}

AlertNavigatorButtons.propTypes = {
  currentAlert: _propTypes["default"].number.isRequired,
  alertsLength: _propTypes["default"].number.isRequired,
  onPrev: _propTypes["default"].func,
  onNext: _propTypes["default"].func
};
AlertNavigatorButtons.defaultProps = {
  currentAlert: 0,
  alertsLength: 0
};

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/arrow--right_16");

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = AlertContainer;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _AlertMessage = _interopRequireDefault(__webpack_require__(118));

var _AlertGoToAction = _interopRequireDefault(__webpack_require__(119));

var _AlertPropTypes = __webpack_require__(54);

var _AlertContainer = _interopRequireDefault(__webpack_require__(397));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var alertContainerClassName = _AlertContainer["default"].alertContainerClassName.replace(/"/g, '');

function isEmpty(item) {
  return item === undefined || item === null || item === '';
}

function isActionEmpty(alert) {
  return !alert || !alert.action || isEmpty(alert.action.label) && isEmpty(alert.action.id) && isEmpty(alert.action.url);
}

function AlertContainer(props) {
  var alert = props.alert,
      className = props.className,
      onDismiss = props.onDismiss,
      onGoToAction = props.onGoToAction;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className + " " + alertContainerClassName
  }, alert && /*#__PURE__*/_react["default"].createElement(_AlertMessage["default"], {
    alert: alert,
    onDismiss: onDismiss
  }), !isActionEmpty(alert) && /*#__PURE__*/_react["default"].createElement(_AlertGoToAction["default"], {
    action: alert.action,
    onGoToAction: onGoToAction
  }));
}

AlertContainer.propTypes = {
  alert: _AlertPropTypes.alertModel,
  className: _propTypes["default"].string,
  onDismiss: _propTypes["default"].func,
  onGoToAction: _propTypes["default"].func
};
AlertContainer.defaultProps = {
  className: ''
};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = AlertMessage;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _information_ = _interopRequireDefault(__webpack_require__(392));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _link = _interopRequireDefault(__webpack_require__(29));

var _AlertPropTypes = __webpack_require__(54);

var _AlertMessage = _interopRequireDefault(__webpack_require__(393));

var _StringResource = _interopRequireDefault(__webpack_require__(114));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var alertMessageClassName = _AlertMessage["default"].alertMessageClassName.replace(/"/g, '');

var messageContainerClassName = _AlertMessage["default"].messageContainerClassName.replace(/"/g, '');

var dismissContainerClassName = _AlertMessage["default"].dismissContainerClassName.replace(/"/g, '');

var optionalTitleClassName = _AlertMessage["default"].optionalTitleClassName.replace(/"/g, '');

function renderOptionalTitle(title) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
    iconId: _information_["default"].id
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: optionalTitleClassName
  }, title));
}

function AlertMessage(props) {
  var alert = props.alert,
      onDismiss = props.onDismiss;

  if (!alert) {
    return false;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: alertMessageClassName
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: messageContainerClassName
  }, alert.title && renderOptionalTitle(alert.title), alert.message), /*#__PURE__*/_react["default"].createElement("div", {
    className: dismissContainerClassName
  }, /*#__PURE__*/_react["default"].createElement(_link["default"], {
    onClick: onDismiss
  }, _StringResource["default"].get('dismiss'))));
}

AlertMessage.propTypes = {
  alert: _AlertPropTypes.alertModel,
  onDismiss: _propTypes["default"].func
};

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = AlertGoToAction;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _button = _interopRequireDefault(__webpack_require__(15));

var _arrowRight_ = _interopRequireDefault(__webpack_require__(116));

var _AlertGoToAction = _interopRequireDefault(__webpack_require__(395));

var _AlertPropTypes = __webpack_require__(54);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var alertGoToActionClassName = _AlertGoToAction["default"].alertGoToActionClassName.replace(/"/g, '');

function _onClick(action, callback) {
  var url = action.url;

  if (url) {
    window.open(url, '_blank');
  }

  if (callback) {
    callback(action);
  }
}

function AlertGoToAction(props) {
  var action = props.action,
      onGoToAction = props.onGoToAction;
  return /*#__PURE__*/_react["default"].createElement(_button["default"], {
    className: alertGoToActionClassName,
    iconRight: _arrowRight_["default"].id,
    label: action.label,
    title: action.label,
    onClick: function onClick() {
      return _onClick(props.action, onGoToAction);
    }
  });
}

AlertGoToAction.propTypes = {
  action: _AlertPropTypes.alertActionModel,
  onGoToAction: _propTypes["default"].func
};

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__29__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(383);


/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _PersistentBanner = _interopRequireDefault(__webpack_require__(384));

exports["default"] = _PersistentBanner["default"];
exports.PersistentBanner = _PersistentBanner["default"];

var _AlertContainer = _interopRequireDefault(__webpack_require__(117));

exports.AlertContainer = _AlertContainer["default"];

var _AlertNavigator = _interopRequireDefault(__webpack_require__(112));

exports.AlertNavigator = _AlertNavigator["default"];

var _AlertNavigatorLabel = _interopRequireDefault(__webpack_require__(113));

exports.AlertNavigatorLabel = _AlertNavigatorLabel["default"];

var _AlertNavigatorButtons = _interopRequireDefault(__webpack_require__(115));

exports.AlertNavigatorButtons = _AlertNavigatorButtons["default"];

var _AlertMessage = _interopRequireDefault(__webpack_require__(118));

exports.AlertMessage = _AlertMessage["default"];

var _AlertGoToAction = _interopRequireDefault(__webpack_require__(119));

exports.AlertGoToAction = _AlertGoToAction["default"];

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _AlertNavigator = _interopRequireDefault(__webpack_require__(112));

var _AlertContainer = _interopRequireDefault(__webpack_require__(117));

var _AlertPropTypes = __webpack_require__(54);

var _PersistentBanner = _interopRequireDefault(__webpack_require__(399));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var persistentBannerClassName = _PersistentBanner["default"].persistentBannerClassName.replace(/"/g, '');

var persistentBannerChildClassName = persistentBannerClassName + "-child";

var PersistentBanner = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(PersistentBanner, _Component);

  function PersistentBanner() {
    var _this;

    _this = _Component.call(this) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "prev", function () {
      var currentAlert = _this.state.currentAlert;

      _this.setState({
        currentAlert: Math.max(--currentAlert, 0)
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDismiss", function () {
      var callback = _this.props.onDismiss;

      if (callback) {
        var potentialPromise = callback(_this.state.currentAlert);

        if (potentialPromise && potentialPromise.then) {
          return potentialPromise.then(function () {
            _this.prev();
          });
        }

        _this.prev();
      }

      return Promise.resolve();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "next", function () {
      var currentAlert = _this.state.currentAlert;
      var alertsLength = _this.props.alerts.length;

      _this.setState({
        currentAlert: Math.min(++currentAlert, alertsLength - 1)
      });
    });
    _this.state = {
      currentAlert: 0
    };
    return _this;
  }

  var _proto = PersistentBanner.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        alerts = _this$props.alerts,
        onGoToAction = _this$props.onGoToAction;
    var currentAlert = this.state.currentAlert;
    return alerts && alerts.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: persistentBannerClassName
    }, /*#__PURE__*/_react["default"].createElement(_AlertNavigator["default"], {
      currentAlert: currentAlert,
      alertsLength: alerts.length,
      className: persistentBannerChildClassName,
      onPrev: this.prev,
      onNext: this.next
    }), /*#__PURE__*/_react["default"].createElement(_AlertContainer["default"], {
      alert: alerts[currentAlert],
      className: persistentBannerChildClassName,
      onDismiss: this.onDismiss,
      onGoToAction: onGoToAction
    }));
  };

  return PersistentBanner;
}(_react.Component);

exports["default"] = PersistentBanner;
PersistentBanner.propTypes = {
  /** Alert configuration */
  alerts: _propTypes["default"].arrayOf(_AlertPropTypes.alertModel),

  /** Dismiss callback - will be called with the alert index when a alert is dismissed. */
  onDismiss: _propTypes["default"].func,

  /** GoToAction callback - will be called with the alert.action.id when the goto action is clicked and no url is specified with the action. */
  onGoToAction: _propTypes["default"].func
};

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(386);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-persistent-banner{display:flex;align-items:center;height:40px;color:#fff;font-size:.875rem}.ba-persistent-banner .ba-persistent-banner-child{display:flex;align-items:center;padding-left:16px;height:100%}.ba-alert-navigator{background-color:#000}\n", ""]);

// exports
exports.locals = {
	"persistentBannerClassName": "\"ba-persistent-banner\"",
	"persistentBannerChildClassName": "\"ba-persistent-banner-child\"",
	"alertNavigatorClassName": "\"ba-alert-navigator\""
};

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(388);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-alert-navigator-label{padding-right:16px}\n", ""]);

// exports
exports.locals = {
	"alertNavigatorLabelClassName": "\"ba-alert-navigator-label\""
};

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

var amdi18n={"__root":{"alerts":"Alerts","dismiss":"Dismiss"},"__cs":{"alerts":"Výstrahy","dismiss":"Opustit"},"__da":{"alerts":"Varsler","dismiss":"Afvis"},"__de":{"alerts":"Alerts","dismiss":"Schließen"},"__es":{"alerts":"Alertas","dismiss":"Descartar"},"__fi":{"alerts":"Hälytykset","dismiss":"Ohita"},"__fr":{"alerts":"Alertes","dismiss":"Fermer"},"__hr":{"alerts":"Uzbune","dismiss":"Odbaci"},"__hu":{"alerts":"Riasztások","dismiss":"Elvetés"},"__it":{"alerts":"Avvisi","dismiss":"Rimuovi"},"__ja":{"alerts":"アラート","dismiss":"解放"},"__kk":{"alerts":"Ескертулер","dismiss":"Бас тарту"},"__ko":{"alerts":"경고","dismiss":"닫기"},"__nb":{"alerts":"Varsler","dismiss":"Avvis"},"__nl":{"alerts":"Alerts","dismiss":"Verwijderen"},"__no":{"alerts":"Varsler","dismiss":"Avvis"},"__pl":{"alerts":"Alerty","dismiss":"Zamknij"},"__pt":{"alerts":"Alertas","dismiss":"Indeferir"},"__pt-br":{"alerts":"Alertas","dismiss":"Indeferir"},"__ro":{"alerts":"Alerte","dismiss":"Renunţare"},"__ru":{"alerts":"Оповещения","dismiss":"Отбросить"},"__sl":{"alerts":"Opozorila","dismiss":"Opusti"},"__sv":{"alerts":"Varningar","dismiss":"Avvisa"},"__th":{"alerts":"แจ้งเตือน","dismiss":"ยกเลิก"},"__tr":{"alerts":"Uyarılar","dismiss":"Kapat"},"__zh":{"alerts":"警报","dismiss":"关闭"},"__zh-cn":{"alerts":"警报","dismiss":"关闭"},"__zh-hk":{"alerts":"警示","dismiss":"跳出"},"__zh-mo":{"alerts":"警示","dismiss":"跳出"},"__zh-sg":{"alerts":"警报","dismiss":"关闭"},"__zh-tw":{"alerts":"警示","dismiss":"跳出"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(391);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-alert-navigator-buttons{min-width:80px}.ba-alert-navigator-buttons .ba-common-button.is-variant_solid{min-width:40px;width:40px;padding:0;background-color:#343334}.ba-alert-navigator-buttons .ba-common-button.is-variant_solid:hover:not(.is-disabled):not(.is-tap){background-color:#595859}.ba-alert-navigator-buttons .ba-common-button.is-disabled{opacity:1;background-color:#595859}.ba-alert-navigator-buttons .ba-common-button.is-disabled svg{opacity:0.5}\n", ""]);

// exports
exports.locals = {
	"alertNavigatorButtonsClassName": "\"ba-alert-navigator-buttons\""
};

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/information_16");

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(394);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-alert-message{display:flex;align-items:center;flex-grow:1;padding-right:16px}.ba-alert-message .ba-message-container{display:flex;align-items:center;flex-grow:1}.ba-alert-message .ba-message-container .ba-optional-title{font-weight:600;padding:0 16px 0 8px}.ba-alert-message .ba-message-container .ba-common-svgIcon{min-width:16px}.ba-alert-message .ba-dismiss-container .ba-common-link{color:#fff}.ba-alert-message .ba-dismiss-container .ba-common-link:hover{color:#eaeaea}\n", ""]);

// exports
exports.locals = {
	"toolTipIconClassName": "\"ba-common-svgIcon\"",
	"alertMessageClassName": "\"ba-alert-message\"",
	"messageContainerClassName": "\"ba-message-container\"",
	"dismissContainerClassName": "\"ba-dismiss-container\"",
	"optionalTitleClassName": "\"ba-optional-title\""
};

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(396);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-alert-goto-action.ba-common-button.is-variant_solid{background-color:#000;font-weight:400;padding:0 16px;min-width:fit-content}.ba-alert-goto-action.ba-common-button.is-variant_solid .ba-common-button__label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:106px;max-width:126px}.ba-alert-goto-action.ba-common-button.is-variant_solid:hover:not(.is-disabled):not(.is-tap){background-color:#595859}.ba-alert-goto-action span.ba-common-button__icon.is-right{padding-left:16px}\n", ""]);

// exports
exports.locals = {
	"alertGoToActionClassName": "\"ba-alert-goto-action\""
};

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(398);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-alert-container{background-color:#2d74da;flex-grow:1}\n", ""]);

// exports
exports.locals = {
	"alertContainerClassName": "\"ba-alert-container\""
};

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(400);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-persistent-banner{display:flex;align-items:center;height:40px;color:#fff;font-size:.875rem}.ba-persistent-banner .ba-persistent-banner-child{display:flex;align-items:center;padding-left:16px;height:100%}\n", ""]);

// exports
exports.locals = {
	"persistentBannerClassName": "\"ba-persistent-banner\"",
	"persistentBannerChildClassName": "\"ba-persistent-banner-child\""
};

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.sampleAlertWithActionById = exports.sampleAlertWithEmptyLabelAction = exports.sampleAlertWithEmptyAction = exports.sampleAlertWithAction = exports.sampleAlertwithTitle = exports.sampleSimpleAlert = exports.alertModel = exports.alertActionModel = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var alertActionModel = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  label: _propTypes["default"].string.isRequired,
  url: _propTypes["default"].string
});

exports.alertActionModel = alertActionModel;

var alertModel = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  message: _propTypes["default"].string.isRequired,
  action: alertActionModel
}).isRequired;

exports.alertModel = alertModel;
var sampleSimpleAlert = {
  id: '123',
  message: "Check out what's new"
};
exports.sampleSimpleAlert = sampleSimpleAlert;
var sampleAlertwithTitle = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new"
};
exports.sampleAlertwithTitle = sampleAlertwithTitle;
var sampleAlertWithAction = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: 'Go to release notes',
    url: 'http://www.ibm.com'
  }
};
exports.sampleAlertWithAction = sampleAlertWithAction;
var sampleAlertWithEmptyAction = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: ''
  }
};
exports.sampleAlertWithEmptyAction = sampleAlertWithEmptyAction;
var sampleAlertWithEmptyLabelAction = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: '',
    id: '111'
  }
};
exports.sampleAlertWithEmptyLabelAction = sampleAlertWithEmptyLabelAction;
var sampleAlertWithActionById = {
  id: '123',
  title: 'New Release',
  message: "Check out what's new",
  action: {
    label: 'Go to release notes',
    id: 'openGlobalToast'
  }
};
exports.sampleAlertWithActionById = sampleAlertWithActionById;

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/arrow--left_16");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[382,0]]]);
});